import { useQuery } from '@tanstack/react-query';
import { CampaignSegment } from '../../types/marketing';
import { getSegmentCustomers } from '../../services/marketing';
import useGetMarketingData from './useGetMarketingData';

function useGetSegmentCustomers(
  segment: CampaignSegment | null,
  {
    emptyIfNoFilters = false,
    enabled = true,
  }: {
    emptyIfNoFilters?: boolean;
    enabled?: boolean;
  } = {},
) {
  const { data: marketingData, isFetching: isFetchingMarketing } =
    useGetMarketingData();

  const {
    data,
    isFetching,
    isLoading,
    isError,
    error,
    isSuccess,
    refetch,
    isPlaceholderData,
  } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      'campaign-segment-customers',
      marketingData?.id,
      segment,
      emptyIfNoFilters,
    ],
    queryFn: async () => {
      if (!segment?.filters.length && emptyIfNoFilters) {
        return {
          totalCount: 0,
          customers: [],
          sourceCustomers: [],
          date: new Date(),
        };
      }
      const result = await getSegmentCustomers(marketingData?.id!, segment!);
      return {
        ...result,
        date: new Date(),
      };
    },
    enabled:
      !!segment && !!marketingData?.id && !isFetchingMarketing && enabled,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  return {
    data,
    isFetching,
    isLoading,
    isError,
    error,
    isSuccess,
    refetch,
    isPlaceholderData,
  };
}

export default useGetSegmentCustomers;
